(function(){
  function uncloak(){document.documentElement.classList.remove('sc-cloak');}
  function inAddon(e){return e.closest('.lbtu-widget-container, .lbtu-product-list');}
  function pick(sel,test){var els=document.querySelectorAll(sel);for(var i=0;i<els.length;i++){var e=els[i];if(inAddon(e))continue;if(!test||test(e))return e;}return null;}
  var observer=null,cont=null,line=null,pending=false;
  var KW=/back[\s-]*order|pre[\s-]*order/i;
  var SHIP='Ships same business day (order by 1:30pm CT)';

  function mergeStock(){
    if(!window.SC_STOCK_OV)return;
    if(!window.SC_STOCK||typeof window.SC_STOCK!=='object')window.SC_STOCK={};
    for(var k in window.SC_STOCK_OV){window.SC_STOCK[k]=window.SC_STOCK_OV[k];}
    window.SC_STOCK_OV=null;
  }

  function heroVideo(){
    var cfg=window.SC_HERO;if(!cfg)return;
    var wrapper=document.querySelector('.product__media-wrapper');if(!wrapper)return;
    if(wrapper.querySelector('.sc-hero'))return;
    var viewer=wrapper.querySelector('[id^="GalleryViewer"], [id*="GalleryViewer"], media-gallery .product__media-list');
    if(!viewer)return;
    var src=cfg.sq||'https://cdn.shopify.com/videos/c/o/v/5c40940a5cfd4fe18d7f108fd92a7911.mp4';if(!src)return;
    viewer.style.display='none';
    var hero=document.createElement('div');hero.className='sc-hero';
    var vid=document.createElement('video');vid.className='sc-hero-video';
    vid.muted=true;vid.defaultMuted=true;vid.loop=true;vid.autoplay=true;vid.playsInline=true;
    vid.setAttribute('muted','');vid.setAttribute('playsinline','');vid.setAttribute('loop','');vid.setAttribute('autoplay','');vid.preload='auto';
    vid.style.cssText='display:block;width:100%;height:auto;aspect-ratio:1/1;object-fit:cover;object-position:50% 50%;background:#f4f4f4;';
    function fitRatio(){if(vid.videoWidth&&vid.videoHeight){vid.style.aspectRatio=vid.videoWidth+' / '+vid.videoHeight;vid.style.objectFit='contain';}}
    vid.addEventListener('loadedmetadata',fitRatio);
    var s=document.createElement('source');s.src=src;s.type='video/mp4';vid.appendChild(s);
    hero.appendChild(vid);
    viewer.parentNode.insertBefore(hero,viewer);
    if(vid.videoWidth)fitRatio();

    var toggle=document.createElement('button');toggle.type='button';toggle.className='sc-hero-toggle';toggle.textContent='See Photos';
    toggle.style.cssText='position:absolute;z-index:6;right:12px;bottom:12px;background:rgba(0,0,0,.72);color:#fff;border:none;border-radius:999px;padding:8px 16px;font-size:13px;font-weight:600;line-height:1;cursor:pointer;-webkit-backdrop-filter:blur(4px);backdrop-filter:blur(4px);white-space:nowrap;box-shadow:0 1px 6px rgba(0,0,0,.25);';
    if(getComputedStyle(hero).position==='static')hero.style.position='relative';
    if(getComputedStyle(viewer).position==='static')viewer.style.position='relative';
    hero.appendChild(toggle);

    function playVid(){if(vid.paused){var p=vid.play();if(p&&p.catch){p.catch(function(){});}}}
    function inVideo(){return hero.style.display!=='none';}
    function showPhotos(){if(inVideo()){hero.style.display='none';viewer.style.display='';toggle.textContent='See Video';try{vid.pause();}catch(e){}}if(toggle.parentNode!==viewer)viewer.appendChild(toggle);}
    function showVideo(){hero.style.display='';viewer.style.display='none';toggle.textContent='See Photos';if(toggle.parentNode!==hero)hero.appendChild(toggle);playVid();}
    window.SC_showPhotos=showPhotos;

    toggle.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();if(inVideo()){showPhotos();}else{showVideo();}});

    var thumbs=wrapper.querySelector('[id*="GalleryThumbnails"], .thumbnail-list');
    if(thumbs){thumbs.addEventListener('click',function(){showPhotos();},true);}

    vid.addEventListener('canplay',playVid);vid.addEventListener('loadeddata',playVid);playVid();
    if('IntersectionObserver' in window){var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting&&inVideo()){playVid();}});},{threshold:0.1});io.observe(vid);}

    if(!window.SC_VARHOOK){
      window.SC_VARHOOK=true;
      function isVariantControl(t){
        if(!t||!t.closest)return false;
        if(t.closest('.lbtu-widget-container, .lbtu-product-list'))return false;
        return !!t.closest('.product__info-container, .globo-swatch-product-detail, variant-radios, variant-selects, .product-form');
      }
      document.addEventListener('change',function(e){
        var t=e.target;if(!t)return;
        if((t.matches&&t.matches('select, input[type="radio"]'))&&isVariantControl(t)){
          if(window.SC_showPhotos)window.SC_showPhotos();
        }
      },true);
      document.addEventListener('click',function(e){
        var t=e.target;if(!t||!t.closest)return;
        if(t.closest('.lbtu-widget-container, .lbtu-product-list'))return;
        if(t.closest('.swatch-anchor, .swatch__button, .dropdown-button-gsw__option, .globo-swatch-item, [data-globo-variant]')){
          if(window.SC_showPhotos)window.SC_showPhotos();
        }
      },true);
    }
  }

  function deviceLink(){
    if(!cont||!window.SC_HERO)return;
    if(document.querySelector('.sc-pick-link'))return;
    var mw=document.querySelector('.product__media-wrapper');
    var grid=mw?mw.parentElement:null;
    if(!grid)return;
    var a=document.createElement('a');a.href='#';a.className='sc-pick-link';
    a.appendChild(document.createTextNode('Select your device & color '));
    var ar=document.createElement('span');ar.className='sc-pick-arrow';ar.textContent='↓';a.appendChild(ar);
    a.addEventListener('click',function(e){e.preventDefault();var t=cont.querySelector('.globo-swatch-product-detail')||cont.querySelector('variant-radios')||cont.querySelector('.product-form__input')||cont.querySelector('select');if(t){t.scrollIntoView({behavior:'smooth',block:'center'});}});
    grid.parentNode.insertBefore(a,grid);
  }

  function displayTitle(){
    if(!cont)return;
    var wrap=cont.querySelector('.product__title');
    var h1=wrap?wrap.querySelector('h1'):null;
    if(!h1||wrap.querySelector('.sc-display-title'))return;
    var d=window.SC_DISPLAY;
    if(!d||!d.brand)return;
    var dt=document.createElement('div');dt.className='sc-display-title';
    var b=document.createElement('span');b.className='sc-dt-brand';b.textContent='SHOWCASED® '+d.brand;dt.appendChild(b);
    if(d.device){var dv=document.createElement('span');dv.className='sc-dt-device';dv.textContent=d.device;dt.appendChild(dv);}
    h1.classList.add('sc-visually-hidden');
    wrap.insertBefore(dt,h1);
  }

  function styleVariantBox(){
    if(!cont)return;
    cont.querySelectorAll('.dropdown-button-gsw').forEach(function(b){b.style.setProperty('border','1px solid #000','important');});
    cont.querySelectorAll('.select__select, select').forEach(function(s){if(inAddon(s))return;s.style.setProperty('border','1px solid #000','important');s.style.setProperty('box-shadow','none','important');});
  }

  function marqueeTrust(){
    var strip=document.querySelector('.sc-trust-strip');
    if(!strip||strip.querySelector('.sc-trust-track'))return;
    var items=[].slice.call(strip.children).filter(function(c){return c.classList&&c.classList.contains('sc-trust-item');});
    if(items.length<2)return;
    var track=document.createElement('div');track.className='sc-trust-track';
    items.forEach(function(it){track.appendChild(it);});
    items.forEach(function(it){var c=it.cloneNode(true);c.setAttribute('data-sc-clone','');c.setAttribute('aria-hidden','true');track.appendChild(c);});
    strip.appendChild(track);
  }

  function consolidatePrice(){
    if(!cont||!line||!line.isConnected)return;
    var strays=[];
    cont.querySelectorAll('.price').forEach(function(p){if(!inAddon(p)&&!p.closest('.sc-meta-line'))strays.push(p);});
    if(!strays.length)return;
    if(observer)observer.disconnect();
    var fresh=strays[strays.length-1];
    var old=line.querySelector('.price');
    if(old)old.remove();
    strays.forEach(function(p){if(p!==fresh)p.remove();});
    line.insertBefore(fresh,line.firstChild);
    if(observer&&cont)observer.observe(cont,{childList:true,subtree:true});
  }

  function variantId(){
    var idEl=cont&&cont.querySelector('[name="id"]');
    var id=(idEl&&idEl.value)||new URL(location.href).searchParams.get('variant');
    return id?String(id):'';
  }
  function variantName(){
    try{
      var p=window.ShopifyAnalytics&&ShopifyAnalytics.meta&&ShopifyAnalytics.meta.product;
      var id=variantId();
      if(p&&p.variants&&id){var cur=p.variants.find(function(v){return String(v.id)===id;});if(cur&&cur.name)return cur.name;}
    }catch(e){}
    var t=cont&&cont.querySelector('.product__title h1');
    return t?t.textContent:'';
  }
  function shouldHide(){
    var buy=cont&&cont.querySelector('.product-form__submit, [name=add]');
    var bt=buy?(buy.textContent||''):'';
    if(/sold out|unavailable|notify me/i.test(bt))return true;
    var sc=window.SC_STOCK;
    if(sc&&typeof sc==='object'){
      var q=sc[variantId()];
      return !(typeof q==='number'&&q>0);
    }
    if(KW.test(variantName()))return true;
    if(KW.test(decodeURIComponent(location.pathname)))return true;
    if(/back[\s-]*order|pre[\s-]*order/i.test(bt))return true;
    return false;
  }
  function stockBadge(){
    if(!cont)return;
    var badge=cont.querySelector('.sc-stock-badge');
    if(!badge){
      badge=document.createElement('div');badge.className='sc-stock-badge';
      badge.appendChild(document.createTextNode(SHIP));
      if(line&&line.isConnected){line.insertAdjacentElement('afterend',badge);}
      else{var buy=cont.querySelector('.product-form__submit');var anchor=buy?buy.closest('.product__info-container > *'):null;if(anchor&&anchor.parentNode===cont){cont.insertBefore(badge,anchor);}else{return;}}
    }
    badge.hidden=shouldHide();
  }
  function stickyShip(){
    var bar=document.getElementById('stickyAtc');
    if(!bar)return;
    var strip=bar.querySelector('.sc-sticky-ship');
    if(!strip){
      strip=document.createElement('div');strip.className='sc-sticky-ship';
      var dot=document.createElement('span');dot.className='sc-sticky-dot';strip.appendChild(dot);
      var tx=document.createElement('span');tx.className='sc-sticky-txt';tx.textContent=SHIP;strip.appendChild(tx);
      bar.insertBefore(strip,bar.firstChild);
    }
    strip.hidden=shouldHide();
  }

  function refresh(){consolidatePrice();stockBadge();stickyShip();heroVideo();deviceLink();styleVariantBox();marqueeTrust();}
  function schedule(){if(pending)return;pending=true;requestAnimationFrame(function(){pending=false;refresh();});}
  function onChange(){schedule();setTimeout(refresh,200);setTimeout(refresh,650);}

  function build(){
    mergeStock();
    heroVideo();
    cont=document.querySelector('.product__info-container');
    if(!cont){uncloak();return true;}
    var title=cont.querySelector('.product__title');
    if(!title)return false;
    displayTitle();
    deviceLink();
    if(cont.querySelector('.sc-meta-line')){uncloak();stockBadge();stickyShip();styleVariantBox();marqueeTrust();return true;}
    var price=pick('.product__info-container .price');
    var rating=cont.querySelector('.product__title + .shopify-app-block')||pick('.product__info-container .shopify-app-block');
    var duties=pick('.product__info-container .sc-dt');
    var parts=[price,rating,duties].filter(Boolean);
    if(parts.length<2)return false;
    line=document.createElement('div');line.className='sc-meta-line';
    parts.forEach(function(el){line.appendChild(el);});
    title.insertAdjacentElement('afterend',line);
    uncloak();
    stockBadge();stickyShip();styleVariantBox();marqueeTrust();
    observer=new MutationObserver(schedule);
    observer.observe(cont,{childList:true,subtree:true});
    cont.addEventListener('change',onChange,true);
    document.addEventListener('click',function(e){if(e.target.closest&&e.target.closest('.product__info-container'))onChange();},true);
    return true;
  }
  function init(){
    if(build())return;
    var n=0;var iv=setInterval(function(){n++;if(build()||n>40){clearInterval(iv);uncloak();}},150);
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
})();
